/*
 * @Author: Gao Deng gaodeng@nextmar.com
 * @Date: 2025-05-08 16:51:44
 * @LastEditors: 刘行 liuhang@nextmar.com
 * @LastEditTime: 2025-06-05 15:35:00
 * @FilePath: /zeelool-nextjs/src/components/UpdateAddressDialog/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Address, { AddressFormData } from '@/components/Address';
import Dialog from '@/components/Dialog';
import { ResponsiveContext } from '@/components/Responsive/ResponsiveProvider';
import { EPlatform } from '@/utils/enums/platform-enum';
import { useTranslations } from 'next-intl';
import { useContext } from 'react';
import Popup from '../Popup';
import WapOnly from '../Responsive/WapOnly';
import WebOnly from '../Responsive/WebOnly';
interface IUpdateAddressDialogProps {
  address: AddressFormData;
  open: boolean;
  onSubmit: (address: AddressFormData) => void;
  onClose: () => void;
}

export default function UpdateAddressDialog({
  address,
  open,
  onSubmit,
  onClose,
}: IUpdateAddressDialogProps) {
  const deviceType = useContext(ResponsiveContext);
  const t = useTranslations('account.myAddressBook.updateAddress');
  return (
    <>
      <WebOnly>
        <Dialog.Info
          title={t('modifyAddress')}
          open={open}
          maxWidth="lg"
          onClose={onClose}
          PaperProps={{
            sx: {
              width: deviceType.deviceType === EPlatform.WEB ? '500px' : '90%',
              height: deviceType.deviceType === EPlatform.WEB ? '75vh' : '70vh',
            },
          }}
        >
          <Address
            data={address}
            type="EDIT"
            onSubmit={onSubmit}
            showCancel={false}
            showDefault={false}
            disabledCountry
          />
        </Dialog.Info>
      </WebOnly>
      <WapOnly>
        <Popup
          open={open}
          onClose={onClose}
          height={550}
          title={t('modifyAddress')}
          bodyClassName="!pb-0"
          sx={{
            '& .flex.flex-row.pl-16.pr-16.flex-wrap.MuiBox-root': {
              padding: '0',
            },
          }}
        >
          <Address
            data={address}
            type="EDIT"
            onSubmit={onSubmit}
            showCancel={false}
            showDefault={false}
            disabledCountry
          />
        </Popup>
      </WapOnly>
    </>
  );
}
